import { render, staticRenderFns } from "./CourseFileHeader.vue?vue&type=template&id=66111eeb&scoped=true"
import script from "./CourseFileHeader.vue?vue&type=script&lang=js"
export * from "./CourseFileHeader.vue?vue&type=script&lang=js"
import style0 from "./CourseFileHeader.vue?vue&type=style&index=0&id=66111eeb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66111eeb",
  null
  
)

export default component.exports